import request from '@/utils/request'

// 查询设备参数信息列表分页
export function fetchList(query) {
    return request({
        url: '/fix/dev/pressure/page',
        method: 'get',
        params: query,
    })
}
// 查询设备参数详细
export function getObj(id) {
    return request({
        url: '/fix/model/detail?id=' + id,
        method: 'get',
    })
}
// 新增设备参数
export function addObj(data) {
    return request({
        url: '/fix/model/add',
        method: 'post',
        data: data,
    })
}

// 修改设备参数
export function putObj(data) {
    return request({
        url: '/fix/dev/pressure/edit',
        method: 'post',
        data: data,
    })
}
// 删除设备参数
export function delObj(data) {
    return request({
        url: '/fix/model/delete',
        method: 'post',
        data: data,
    })
}
// 禁用设备参数
export function statusObj(data) {
    return request({
        url: '/fix/model/status',
        method: 'get',
        params: data,
    })
}